import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { RegisterStepType } from 'src/app/domain/enums/register-step-types.enum';
import { RegisterService } from '../../../../shared/services/register.service';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: [],
})
export class ConfirmationComponent implements OnInit {
  private readonly notifier: NotifierService
  tenant: string = '';
  public loading: boolean;

  constructor(
    private readonly router: Router,
    notifierService: NotifierService,
    private readonly route: ActivatedRoute,
    private readonly registerService: RegisterService,
  ) {
    this.notifier = notifierService;
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const result = params.get('tenant');

      if (result)
        this.tenant = params.get('tenant');
    });

  }

  goHome() {
    this.loading = true;
    this.registerService.putRegisterStep(RegisterStepType.RegisterConfirm).subscribe({
      next: (stepResult) => {
        this.loading = false;
        this.router.navigate([`${this.tenant}/home`]);
      },
      error: (err) => {
        this.loading = false;
      },
    });
  }

}
